angular.module('impactx.login').controller('LoginCXMLCtrl', LoginCXMLCtrl);

LoginCXMLCtrl.$inject = ['LoginService', '$securityManager', '$routeParams', 'dataGen'];

function LoginCXMLCtrl(LoginService, $securityManager, $routeParams, dataGen) {
    var token = $routeParams.token;
    $securityManager.setToken(token);
    dataGen.getData({}, {}, "/cxml/login").then(function(data) {
        var help = null;
        if (data && data.data && data.data.proId) {
            help = '/product/' + data.data.proId;
        }
        LoginService.refreshUI(true, null, help);
    });
}
